<template>
  <div id="main-banner" class=" bg-primary-subtle">
    <div class="base_banner opacity-75"></div>
    <div id="display1" class="w-100 text-center text-white position-absolute animate__animated animate__slow animate__delay">
      <p>VENHA MUDAR A POLÍTICA. <br> A MUDANÇA COMEÇA EM CADA UM DE NÓS!</p>
    </div>
  </div>
</template>

<script>
import {efeito} from '@/assets/js/functions'

export default {
  name: "Banner",
  mounted() {
    efeito('display1', 99999, 'fadeInUp')
  }
};
</script>

<style scoped>
.base_banner {
  width: 100%;
  height: 100%;
}

#display1 {
  font-size: 2.5rem !important;
  font-weight: 900;
}

#main-banner {
  background-image: url("/public/img/banner-home.jpg");
  background-position: 0 0px;
  background-size: cover;
  background-repeat: no-repeat;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: var(--cor-base-texto) 8px Outset;
}

#main-banner .h6 {
  color: #fa6d13;
  border-bottom: 3px solid #fa6d13;
}

#main-banner .h2 {
  color: #fff;
  text-align: left;
  background-color: #222;
  padding: 20px 40px;
  border-radius: 0 14px 14px 0;
  max-width: 60vw;
}
</style>